import { MODAL_SIZES, ModalBody } from 'ui/modal';
import { DisplayTextInput } from './DisplayTextInput';
import { HrefTextInput } from './HrefTextInput';
import { TargetSelect } from './TargetSelect';

export const Body = () => (
  <ModalBody size={MODAL_SIZES.MEDIUM}>
    <DisplayTextInput />
    <HrefTextInput />
    <TargetSelect />
  </ModalBody>
);
